import {FocusedImage} from 'image-focus';

/**
 * FocusPointController
 */
export default class FocusPointController {
  private focusedImages: FocusedImage[] = [];

  /**
   * Public function to init class
   */
  constructor() {
    const images: NodeListOf<HTMLImageElement> = document.querySelectorAll('.focused-image');
    for (let i = 0; i < images.length; i++) {
      if (images[i].dataset.focusArea) {
        const focusData = JSON.parse(images[i].dataset.focusArea || '');
        const x = 'x';
        const y = 'y';
        const width = 'width';
        const height = 'height';
        const focusX = parseInt(focusData[x] + (focusData[width] / 2) || '0', 10);
        const focusY = parseInt(focusData[y] + (focusData[height] / 2) || '0', 10);
        const originalWidth = parseInt(images[i].dataset.originalWidth || '1920', 10);
        const originalHeight = parseInt(images[i].dataset.originalHeight || '1000', 10);

        let imageX;
        let imageY;

        imageX = (focusX / originalWidth * 2 - 1);
        imageY = (focusY / originalHeight * 2 - 1) * -1;

        this.focusedImages.push(new FocusedImage(images[i], {
          focus: {
            x: isFinite(imageX) ? imageX : 1,
            y: isFinite(imageY) ? imageY : 1,
          },
        }));

        window.dispatchEvent(new Event('resize'));
      }
    }
  }
}
